import { IAmount, TOperationDate } from '../types/operations.types';

export const operationtypes = {
  CARD_TOPUP: 'cardTopup',
  BANK_TRANSFERT: 'bankTransfer',
  BANK_DIRECT_DEBIT: 'bankDirectDebit',
  CHECK: 'check',
  INSTANT_BANK_TRANSFERT: 'instantBankTransfer',
  WALLET_TRANSFERT: 'walletTransfer',
  FEES: 'fees',
  CREDIT_NOTE: 'creditNote',
  CARD_TRANSACTION: 'cardTransaction',
  OTHER: 'other',
  PAYIN_REFUND: 'payinRefund',
  PAYOUT_REFUND: 'payoutRefund',
  TRANSFERT_REFUND: 'transferRefund',
  INT_BANK_TRANSFERT: 'intBankTransfer',
} as const;

export type TOperationType = (typeof operationtypes)[keyof typeof operationtypes];

export const operationsZones = {
  HEADER_TABLE: 'headerTable',
  FILTERS_FORM: 'filtersForm',
  FILTERS: 'filters',
  POPIN: 'popin',
  GLOBAL: 'global',
  ACTION: 'action',
};
export type TOperationsZones = (typeof operationsZones)[keyof typeof operationsZones];

export const operationStatus = {
  CREATED: 'CREATED',
  COMPLETED: 'COMPLETED',
  NO_REQUEST: 'NO_REQUEST',
  PENDING: 'PENDING',
  CANCELED: 'CANCELED',
  AUTHORIZED: 'AUTHORIZED',
  SETTLED: 'SETTLED',
  DECLINED: 'DECLINED',
} as const;
export type TOperationStatus = (typeof operationStatus)[keyof typeof operationStatus];

export type TOperationFilterStatus = Extract<
  TOperationStatus,
  | typeof operationStatus.AUTHORIZED
  | typeof operationStatus.CANCELED
  | typeof operationStatus.DECLINED
  | typeof operationStatus.SETTLED
>;

export const operationDirections = { CREDIT: 'CREDIT', DEBIT: 'DEBIT' } as const;
export type TOperationDirection = (typeof operationDirections)[keyof typeof operationDirections];

export const initialFlows = {
  PAYIN: 'payin',
  PAYIN_REFUND: 'payinRefund',
  PAYOUT: 'payout',
  PAYOUT_REFUND: 'payoutRefund',
  TRANSFERT: 'transfer',
  CARD_TRANSACTION: 'cardTransaction',
  CHARGE_BACK: 'chargeback',
} as const;
export type TInitialFlow = (typeof initialFlows)[keyof typeof initialFlows];

export interface IOperationBase {
  objectId: string;
  date: TOperationDate;
  status: Extract<
    TOperationStatus,
    | typeof operationStatus.PENDING
    | typeof operationStatus.CANCELED
    | typeof operationStatus.AUTHORIZED
    | typeof operationStatus.SETTLED
    | typeof operationStatus.DECLINED
  >;
  amount: IAmount;
  direction: TOperationDirection;
  label: string;
  walletId: number;
}
